const createDOMPurify = require('dompurify');
const { JSDOM } = require('jsdom');
const window = new JSDOM('').window;
const DOMPurify = createDOMPurify(window);

export function createMarkup(content) {
  return { __html: DOMPurify.sanitize(content) };
}
